import { Collapse } from '@chakra-ui/react';
import { ChevronDownIcon } from '@sketchnote/icons';
import * as React from 'react';
import { useBoardStore } from 'src/features/boards';
import { shallow } from 'zustand/shallow';

import { useKanbanStore } from '../..';
import { KanbanState } from '../../store/types';
import { ColumnToolbar } from './Toolbar';
export interface KanbanColumnListProps {
  children: JSX.Element | JSX.Element[];
  data: {
    id: string;
    name: string;
    color: string;
    index: number;
  };
}

const { useState, useEffect } = React;

export const KanbanColumnList = ({
  children,
  data: { name, color, id, index },
}: KanbanColumnListProps) => {
  const [isEditColumnTitle, setIsEditColumnTitle] = useState(false);
  const [changeName, setChangeName] = useState('');
  const [collapse, setCollapse] = useState(true);
  const boardsStore = useBoardStore();
  const {
    onChangeColumnName,
    onChangeColumnColor,
    onUpdateItemPlacement,
    onDeleteColumn,
    isReadOnly,
  } = useKanbanStore(boardSelector, shallow);

  useEffect(() => {
    setChangeName(name);
  }, [name]);

  const handleColumnChange = (e) => {
    if (e.value === 'delete') {
      onDeleteColumn({ columnId: id });
    } else if (e.value != 'colour-picker') {
      onChangeColumnColor({ id: id, color: e.value });
    }
  };

  return (
    <div className="w-full no-scrollbar overflow-auto">
      <div className="w-full mt-32">
        <div
          role="button"
          className="w-full flex items-center justify-between pb-10 border-b"
          onClick={() => {
            setCollapse(!collapse);
          }}
        >
          <div className="flex">
            <span
              style={{
                transform: collapse ? 'rotate(0deg)' : 'rotate(-90deg)',
                transition: 'all 0.5s',
              }}
              className={'mt-4 block'}
            >
              <ChevronDownIcon />
            </span>
            {!isReadOnly && isEditColumnTitle && boardsStore.access !== 'view' ? (
              <input
                className="border border-gray-200 rounded-md px-9 py-6 bg-white "
                autoFocus
                onChange={(e) => {
                  setChangeName(e.target.value);
                }}
                value={changeName}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    onChangeColumnName({ id: id, name: changeName });
                    setIsEditColumnTitle(false);
                  }
                }}
                onBlur={() => {
                  onChangeColumnName({ id: id, name: changeName });
                  setIsEditColumnTitle(false);
                }}
              />
            ) : (
              <span
                style={{ fontWeight: '450', backgroundColor: color }}
                className="px-8 py-2 rounded-sm font-medium "
                onDoubleClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setIsEditColumnTitle(true);
                }}
              >
                {name}
              </span>
            )}
          </div>
          <div className="mr-10 text-gray-500">
            {!isReadOnly && boardsStore.access !== 'view' ? (
              <ColumnToolbar onClick={handleColumnChange} />
            ) : null}
          </div>
        </div>
      </div>
      <div className="w-full overflow-auto no-scrollbar">
        <Collapse in={collapse} className="overflow-auto no-scrollbar" style={{ overflow: 'auto' }}>
          <div className="mt-32">{children}</div>
        </Collapse>
      </div>
    </div>
  );
};

const boardSelector = (s: KanbanState) => ({
  onChangeColumnName: s.onChangeColumnName,
  onChangeColumnColor: s.onChangeColumnColor,
  onUpdateItemPlacement: s.onUpdateItemPlacement,
  onDeleteColumn: s.onDeleteColumn,
  isReadOnly: s.isReadOnly,
});
